export default __webpack_public_path__ + "static/media/leohacker.46104397.png";